import script from "./WidgetTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetTickets.vue?vue&type=script&setup=true&lang=js"

import "./WidgetTickets.vue?vue&type=style&index=0&id=378e208e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378e208e"]])

export default __exports__